import { get } from '../Services/http';
import { catchError } from './Error.action';
import { dispatchCustomEvent } from '../Events/dispatchCustomEvent';

export const FACETED_SEARCH_QUERY = "FACETED_SEARCH_QUERY";
export const FACETED_SEARCH_RECEIVE = "FACETED_SEARCH_RECEIVE";
export const FACETED_SEARCH_ERROR = "FACETED_SEARCH_ERROR";
export const FACETED_SEARCH_TOGGLE_VALUE = "FACETED_SEARCH_TOGGLE_VALUE";
export const FACETED_SEARCH_TOGGLE_COMPACT = "FACETED_SEARCH_TOGGLE_COMPACT";
export const FACETED_SEARCH_TOGGLE_SHOWMORE = "FACETED_SEARCH_TOGGLE_SHOWMORE";
export const FACETED_SEARCH_VISIBLE_GROUPS = "FACETED_SEARCH_VISIBLE_GROUPS";
export const PRODUCT_VIEW_CACHED = "PRODUCT_VIEW_CACHED";

export const query = (queryString = '', withHtmlResult = true, productId = '', productsViewCachedId = (new Date()).getTime() + '') => (dispatch, getState) => {
    if (productId === '') {
        let url = withHtmlResult ? '/api/productFilter/withHtmlResult' : '/api/productFilter'
        if (queryString && queryString.trim() !== '') {
            url += `?${queryString}`;
        }
        return get(url)
                .then(response => response.json())
                .then(result => {
                    const {productsView, sortCriteria, subNavigation, ...others} = result;
                    if (withHtmlResult) {
                        window.__litium.cache[PRODUCT_VIEW_CACHED] = {
                            productsViewCachedId,
                            productsView,
                        };
                    }
                    result = {
                        ...others,
                        sortCriteria,
                        subNavigation,
                        productsViewCachedId,
                    }
                    dispatch(receive(result));
                    queryString && queryString.trim() !== '' ? UpdateLinkWithQueryString(`?${queryString}`) : UpdateLinkWithQueryString('');
                    dispatchCustomEvent('facetSearchActionLoading', { isLoading: false });
                })
                .catch(ex => {
                    dispatch(catchError(ex, error => searchError(error)))
                    dispatchCustomEvent('facetSearchActionLoading', { isLoading: false });
                });
    } else {
        let url = '/api/productFilter/variantSelector';
        if (queryString && queryString.trim() !== '') {
            url += `?${queryString}&productId=${productId}`;
        } else {
            url += `?productId=${productId}`;
        }
        return get(url)
                .then(response => response.json())
                .then(result => {
                    const {productsView, sortCriteria, subNavigation, ...others} = result;
                    window.__litium.cache[PRODUCT_VIEW_CACHED] = {
                        productsViewCachedId,
                        productsView,
                    };
        
                    result = {
                        ...others,
                        sortCriteria,
                        subNavigation,
                        productsViewCachedId,
                    }
                    dispatch(receive(result));
                    queryString && queryString.trim() !== '' ? UpdateLinkWithQueryString(`?${queryString}`) : UpdateLinkWithQueryString('');
                    dispatchCustomEvent('facetSearchActionLoading', { isLoading: false });
                })
                .catch(ex => {
                    dispatch(catchError(ex, error => searchError(error)))
                    dispatchCustomEvent('facetSearchActionLoading', { isLoading: false });
                });
    }
}

const UpdateLinkWithQueryString = (queryString) => {
    document.querySelectorAll('.js-product-item').forEach(item => {
        item.setAttribute('href',item.dataset.href + queryString)
    })
} 

export const setShowAll = (value) => ({
    type: FACETED_SEARCH_TOGGLE_SHOWMORE,
    payload: {
        showAll:  value,
    }
})

export const numberOfGroupsVisible = (value) => ({
    type: FACETED_SEARCH_VISIBLE_GROUPS,
    payload: {
        visibleGroups:  value,
    }
})

const submit = (facetFilters, productId) => (dispatch, getState) => {
    const filterCriteria = toFilterCriteria(facetFilters);
    const filterIds = facetFilters.map(filter => filter.id);
    const ignoredParams = ['page'];
    const unChangedParams = (decodeURI(window.location.search.substr(1)) || '').split('&').filter(param => {
        const [id, value] = param.split('=');
        return param.length > 0 && !filterIds.includes(id) && !ignoredParams.includes(id);
    });
    const q = [...unChangedParams, ...filterCriteria].join('&');
    dispatch(saveQuery(q));
    return dispatch(query(q, true, productId));
}

const toFilterCriteria = facetFilters => facetFilters
    .map(facetFilter => facetFilter.selectedOptions
        .map(selectedOption => `${encodeURIComponent(facetFilter.id)}=${encodeURIComponent(selectedOption.value)}`))
    .reduce((flat, current) => [...flat, ...current], []);

/**
 *
 * @param filter : the group has changed facet
 * @param option : changed facet
 */
export const searchFacetChange = (filter = null, option = null, productId = '') => (dispatch, getState) => {
    if (filter) {
        const allFilters = getState().facetedSearch.facetFilters;
        const newFilters = updateFilterOption(allFilters, filter, option);
        return dispatch(submit(newFilters, productId));
    }
}

export const sliderFilterChange = (filter = null, value = null, productId = '') => (dispatch, getState) => {
    if(filter) {
        const allFilters = getState().facetedSearch.facetFilters;
        const newFilters = updateSliderValue(allFilters,filter,value);
        return dispatch(submit(newFilters, productId));
    }
}

export const updateSliderValue = (allFilters = [], filter = null, value = null) => {
    if(!filter) return allFilters;
    const filterIndex = allFilters.findIndex(f => f.id === filter.id);
    const newFilter = value ? {...filter, selectedOptions : [`${value.min}-${value.max}`]} : {... filter, selectedOptions : []}
    const newFilters = [
        ...allFilters.slice(0, filterIndex),
        newFilter,
        ...allFilters.slice(filterIndex + 1)
    ];
    return newFilters;
}

export const updateFilterOption = (allFilters = [], filter = null, option = null) => {
    if (!filter) return allFilters;
    const filterIndex = allFilters.findIndex(f => f.id === filter.id);
    const newFilter = option ? toggleFilterValue(filter, option) : {...filter, selectedOptions : [] };
    const newFilters = [
        ...allFilters.slice(0, filterIndex),
        newFilter,
        ...allFilters.slice(filterIndex + 1)
    ];
    return newFilters;
}

export const deselectAllFilterOptions = (allFilters = null, productId = '') => (dispatch) => {
    if(allFilters) {
        let newFilters = [];
        allFilters.forEach(filter => newFilters.push({...filter, selectedOptions : []}))
        return dispatch(submit(newFilters, productId));
    }
}

const toggleFilterValue = (filter, option) => {
    const { singleSelect, selectedOptions } = filter;
    if(option.isSlider){
        return{ ...filter, selectedOptions:[]};
    }
    const optionIndex = selectedOptions.findIndex(selected => selected.value === option.id);
    const newSelectedOptions = optionIndex < 0
        // not yet selected, select it
        ? singleSelect ? [{ label: option.label, value: option.id }] : [...selectedOptions, { label: option.label, value: option.id }]
        // selected, deSelect  it
        : [...selectedOptions.slice(0, optionIndex), ...selectedOptions.slice(optionIndex + 1)];
    return { ...filter, selectedOptions: newSelectedOptions};
}

export const submitSearchFacet = allFilters => (dispatch, getState) => {
    dispatch(facetClientChanged(allFilters));
    return dispatch(submit(allFilters));
}

export const facetClientChanged = facetFilters => ({
    type: FACETED_SEARCH_TOGGLE_VALUE,
    payload: {
        facetFilters,
    }
})

export const toggleVisibleDropdownMenu = ({id}) => ({
    type: FACETED_SEARCH_TOGGLE_COMPACT,
    payload: {
        visibleDropdownMenu: id,
    }
})

export const searchError = error => ({
    type: FACETED_SEARCH_ERROR,
    payload: {
        error,
    }
})

export const receive = (payload) => {
    return {
        type: FACETED_SEARCH_RECEIVE,
        payload,
    }
}

export const saveQuery = (queryString) => ({
    type: FACETED_SEARCH_QUERY,
    payload: {
        query: queryString,
    }
})